<script setup lang="ts">
const { mainElement } = useAppElementRefs()
</script>

<template>
  <NuxtLoadingIndicator />
  <ImpersonationWarning />
  <div class="flex-1print:block flex min-h-0">
    <div class="flex min-h-0 flex-1 flex-col overflow-auto">
      <main ref="mainElement" class="flex flex-1 flex-col dark:bg-gray-900 print:h-auto">
        <slot />
      </main>
    </div>
  </div>
</template>
